import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import { Globe } from "lucide-react";

export const LanguageSwitcher = ({ variant = "inline" }) => {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "fr";

  const change = (code) => {
    i18n.changeLanguage(code);
    try {
      localStorage.setItem("sux1_lang", code);
    } catch {
      // ignore
    }
  };

  if (variant === "inline") {
    return (
      <div className="flex items-center gap-1" data-testid="language-switcher" data-tip={t("tips.language", "Langue de l'interface : français ou anglais (n'affecte pas la langue des résumés).")}>
        <Globe className="w-3.5 h-3.5 text-muted-foreground mr-1" />
        {SUPPORTED_LANGUAGES.map((lng) => (
          <button
            key={lng.code}
            onClick={() => change(lng.code)}
            data-testid={`lang-${lng.code}`}
            className={`font-mono uppercase tracking-[0.2em] text-[10px] px-2 py-1 border transition-colors ${
              current === lng.code
                ? "bg-[#002FA7] text-white border-[#002FA7]"
                : "border-transparent hover:border-border text-muted-foreground hover:text-foreground"
            }`}
          >
            {lng.code}
          </button>
        ))}
      </div>
    );
  }

  // settings variant — full labels
  return (
    <div
      className="flex flex-col gap-2"
      data-testid="language-switcher-settings"
    >
      <div className="sux-marker">{t("settings.language")}</div>
      <div className="flex flex-wrap gap-2">
        {SUPPORTED_LANGUAGES.map((lng) => (
          <button
            key={lng.code}
            onClick={() => change(lng.code)}
            data-testid={`lang-${lng.code}`}
            className={`font-mono uppercase tracking-[0.2em] text-[11px] px-4 py-2 border transition-colors flex items-center gap-2 ${
              current === lng.code
                ? "bg-[#002FA7] text-white border-[#002FA7]"
                : "border-border hover:bg-secondary"
            }`}
          >
            <span className="text-base">{lng.flag}</span>
            {lng.label}
          </button>
        ))}
      </div>
    </div>
  );
};
